import ic_play from './player/play.svg'
import ic_pause from './player/pause.svg'
import ic_listeners from './icons/ic_listeners.svg'
import app_logo from './img/logo.png'
import default_art from './img/album_art.png'

const Icons = {
    ic_play,
    ic_pause,
    ic_listeners
}

const Images = {
    app_logo,
    default_art,
}

export {
    Icons,
    Images
}